// Warranty Strip (PROMPT 3.0 §4) — full-width band above footer.
// Amber #F59E0B accent stroke on headline.

import { HOME } from "../constants/testIds";

export default function WarrantyStrip() {
        return (
                <section
                        id="warranty"
                        data-testid={HOME.warrantyStrip}
                        className="bg-[#0A0A0A] text-white py-14 md:py-20 border-t border-white/10"
                >
                        <div className="mx-auto max-w-[1440px] px-6 grid grid-cols-1 md:grid-cols-[1fr_auto] md:items-end gap-6">
                                <div>
                                        <p
                                                data-testid={HOME.warrantyEyebrow}
                                                className="font-mono text-[11px] tracking-[0.18em] text-[#F59E0B] uppercase"
                                        >
                                                WARRANTY · INDIA
                                        </p>
                                        <h2
                                                data-testid={HOME.warrantyHeadline}
                                                className="mt-3 font-display text-[32px] md:text-[48px] leading-[1.02] uppercase"
                                                style={{
                                                        borderLeft: "3px solid #F59E0B",
                                                        paddingLeft: "1rem",
                                                }}
                                        >
                                                18-month domestic warranty with doorstep pickup.
                                        </h2>
                                        <p
                                                data-testid={HOME.warrantySubhead}
                                                className="mt-4 max-w-[640px] font-sans text-[15px] md:text-[16px] text-white/70 leading-relaxed"
                                        >
                                                Every product on Loadout ships covered. If it fails, we come to you.
                                        </p>
                                </div>
                                <a
                                        data-testid={HOME.warrantyCta}
                                        href="/warranty"
                                        className="inline-block border border-[#F59E0B] text-[#F59E0B] font-mono text-[12px] tracking-[0.18em] uppercase px-6 py-4 hover:bg-[#F59E0B] hover:text-black transition-colors self-start md:self-end"
                                >
                                        How it works →
                                </a>
                        </div>
                </section>
        );
}
